import classNames from 'classnames'
import {memo, useCallback} from 'react'

import type {TestOccurrenceId} from '../../../../types'
import Icon from '../../../common/Icon/Icon'
import {getTestOccurrence, getTestOccurrenceInvocationsCounters} from '../Tests.selectors'
import {TestStatus as TestStatusEnum} from '../Tests.types'

import styles from './TestStatus.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  className?: string
  testOccurrenceId?: TestOccurrenceId
  withCounters?: boolean
}

function TestStatus({className, testOccurrenceId, withCounters}: Props) {
  const {status, muted: isMuted} =
    useAppSelector(state => getTestOccurrence(state, testOccurrenceId)) ?? {}
  const {
    all = 0,
    success = 0,
    failed = 0,
    muted = 0,
    ignored = 0,
  } = useAppSelector(state => getTestOccurrenceInvocationsCounters(state, testOccurrenceId)) ?? {}
  const renderStatus = useCallback(
    (count: number, name: string, additionalClassName?: string, icon?: string) => {
      let title = name

      if (withCounters === true && all > 1) {
        title = all === count ? `${count} ${name}` : `${count} of ${all} ${name}`
      }

      return (
        <div className={classNames(styles.status, className, additionalClassName)} title={title}>
          {icon != null ? <Icon className={styles.icon} name={icon} /> : null}
          {title}
        </div>
      )
    },
    [className, all, withCounters],
  )

  if (status === TestStatusEnum.SUCCESS && isMuted !== true) {
    return renderStatus(success, 'Success', styles.success)
  }

  if (status === TestStatusEnum.FAILURE && isMuted !== true) {
    return renderStatus(failed, 'Failure', styles.failed, 'close')
  }

  if (status === TestStatusEnum.UNKNOWN) {
    return renderStatus(ignored, 'Ignored', styles.ignored, 'ignored')
  }

  if (isMuted === true) {
    return renderStatus(muted, 'Muted failure', styles.muted)
  }

  return null
}

export default memo<Props>(TestStatus)
